<script>
export default {
  name: 'UserDeviceMixin',

  methods: {
    get_device(){
      const ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return "tablet";
      }
      else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return "mobile";
      }
      return "desktop";
    }
  },

  computed: {
    centro: function(){
      return this.$store.state.centro.centro
    }
  }
}
</script>
